import React from "react";
import "../../../../Assets/Css/EmployeeProjectNotes.scss";
import Table from "../../../../Components/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import Userimg from '../../../../Assets/Images/Employee/testimonial-3.jpg'
import { getProjectFiles } from "../../../../Services/Project/action";
import { deleteRecord } from "../../../../Services/Delete/action";
import { connect } from "react-redux";
import Pdf from '../../../../Assets/Images/Employee/Pdf.svg'
import Jpg from '../../../../Assets/Images/Employee/Jpg.svg'
import Png from '../../../../Assets/Images/Employee/Png.svg'
import Image from '../../../../Assets/Images/Employee/Image.png'
import ModulesList from "../../../../Assets/ModulesLiist";
import FeaturesList from "../../../../Assets/FeaturesList";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../../Lib/RoleWiseFeatureWrapper";

const EmpProjectNotes = (props) => {
  const [inData, setInData] = useState([]);
  const { projectId, employeeId } = useParams();
  const location = useLocation();

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.ProjectNotes,
    Featur_Name: FeaturesList.Delete,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await props?.getProjectFiles();
    }

    fetchData();
  }, [])

  const header = [
    { field: "ID" },
    { field: "Employee Notes Upload" },
    { field: "Name Of Notes" },
    { field: "Date & Time" },
    { field: "Action" },
  ];


  let footer = true;
  let count = inData?.length;

  useEffect(() => {
    setInData(
      props?.projectFiles?.filter((item) => (item?.project_id == projectId) && (item?.type == 'notes'))?.map((item) => {

        let url;
        const byteArray = new Uint8Array(item.file.data);
        const stringData = new TextDecoder().decode(byteArray);

        let base64String = '';
        let mimeType = '';

        if (stringData.startsWith('data:')) {
          const match = stringData.match(/^data:(.*?);base64,(.*)$/);
          if (match) {
            mimeType = match[1];
            base64String = match[2];
          }
        } else {
          mimeType = 'application/pdf';
          base64String = btoa(String.fromCharCode(...byteArray));
        }

        try {
          const binaryString = atob(base64String);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: mimeType });
          url = URL.createObjectURL(blob);

        } catch (error) {
          console.error('Error decoding base64 or creating blob:', error);
        }

        return {
          ID: {
            value: item?.id,
            type: "text",
          },
          "Employee Notes Upload": {
            image: mimeType?.includes('pdf') ? Pdf : mimeType?.includes('jpg') ? Jpg : mimeType?.includes('png') ? Png : Image,
            type: "images",
          },
          "Name Of Notes": {
            value: item?.name,
            type: "text",
          },
          "Date & Time": {
            value: item?.createdAt,
            type: 'text'
          },
          Action: {
            value2: location?.pathname == `/employees/view/${employeeId}/project/view/${projectId}/notes` ? `/employees/view/${employeeId}/project/view/${projectId}/notes/view` : `/project/employeeproject/view/${projectId}/notes/view`,
            value3: item?.id,
            value1: url,
            fileName: `${item?.project?.name}_${item?.name}_${item?.createdAt}`,
            type: "action",
          },
          allData: {
            ...item
          }
        };
      })
    )
  }, [props?.projectFiles]);

  const handleAddClick = () => {
    location?.pathname?.includes(`/project/employeeproject/view/${projectId}/notes`) ? navigate(`/project/employeeproject/view/${projectId}/notes/add`) : navigate(`/employees/view/${employeeId}/project/view/${projectId}/notes/add`);
  }

  return (

    <div className="emProjectNotes-main">
      <div className="gap-4">
        <RoleWiseFeatureWrapper
          modules={props?.modules}
          features={props?.features}
          user={props?.user}
          ModuleName={ModulesList.ProjectNotes}
          Featur_Name={FeaturesList.Create}>

          <button className="custom-notes-btn" disabled={props.loading} onClick={handleAddClick}>
            {props.loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Add Notes"}
          </button>
        </RoleWiseFeatureWrapper>
      </div>

      <div className="invoice-table-part">
        <Table
          header={header}
          data={inData}
          footer={footer}
          count={count}
          records={count}
          loading={props.loading}
          showIsView={true}
          showIsDownload={true}
          showIsDelete={canDelete}
          deleteRecord={props?.deleteRecord}
        />
      </div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.projectReducer.loading,
    projectFiles: state.projectReducer.projectFiles,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectFiles: () => {
      dispatch(getProjectFiles());
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue));
      await dispatch(getProjectFiles());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpProjectNotes);